import React from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../utils/LanguageContext";
import content from "../../content/termOfService.json"

const TermsOfService = () => {
  const { language, setLanguage } = useLanguage();
  const t = content[language].terms;

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-[#0D2642] shadow-sm">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <Link
            to="/"
            className="inline-flex items-center text-white hover:text-[#1AA06A] text-lg font-medium"
          >
            <ArrowLeft className="w-6 h-6 mr-2" />
            {t.backLink}
          </Link>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-[#333] mb-8">{t.title}</h1>

        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-6">
            <strong>{t.lastUpdated}:</strong>{" "}
            {new Date().toLocaleDateString(
              language === "es" ? "es-ES" : "en-US"
            )}
          </p>

          {Object.entries(t.sections).map(([key, section]) => (
            <section key={key} className="mb-8">
              <h2 className="text-2xl font-semibold text-[#333] mb-4">
                {section.title}
              </h2>

              {section.description && (
                <p className="text-gray-700 mb-4">{section.description}</p>
              )}

              {section.items && (
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  {section.items.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              )}

              {section.subsections &&
                Object.entries(section.subsections).map(([subKey, sub]) => (
                  <div key={subKey} className="mb-4">
                    <h3 className="font-semibold text-[#333]">{sub.title}</h3>
                    <ul className="list-disc pl-6 space-y-1 text-gray-700">
                      {sub.items.map((it, i2) => (
                        <li key={i2}>{it}</li>
                      ))}
                    </ul>
                  </div>
                ))}

              {section.contact && (
                <div className="bg-gray-100 p-4 rounded-lg text-gray-700">
                  <p>
                    <strong>Email:</strong> {section.contact.email}
                    <br />
                    <strong>
                      {language === "es" ? "Dirección" : "Address"}:
                    </strong>{" "}
                    {section.contact.address}
                  </p>
                </div>
              )}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
